// Konfiguracja 4 poziomów nauczenia (4 kolory).
// Lustro backendu: App\Service\Exam\SpacedRepetition\ExamSpacedRepetitionProgressClassifier.
//
// Kolory wg specyfikacji:
//   Bardzo dobrze = ciemnozielony, Dobrze = jasnozielony, Przeciętnie = żółty, Słabo = czerwony.

export const LEVEL_ORDER: ExamSrProgressLevel[] = [
  "bardzo_dobrze",
  "dobrze",
  "przecietnie",
  "slabo",
];

export const LEVEL_LABEL: Record<ExamSrProgressLevel, string> = {
  slabo: "Słabo",
  przecietnie: "Przeciętnie",
  dobrze: "Dobrze",
  bardzo_dobrze: "Bardzo dobrze",
};

// Kolor wycinka wykresu (hex — donut rysowany w SVG).
export const LEVEL_COLOR: Record<ExamSrProgressLevel, string> = {
  bardzo_dobrze: "#16a34a", // ciemnozielony
  dobrze: "#4ade80", // jasnozielony
  przecietnie: "#facc15", // żółty
  slabo: "#ef4444", // czerwony
};

// Chip poziomu przy pytaniu (pełne literały klas — wymóg purge Tailwind).
export const LEVEL_BADGE_CLASS: Record<ExamSrProgressLevel, string> = {
  bardzo_dobrze: "bg-green-100 text-green-800 border-green-200",
  dobrze: "bg-green-50 text-green-600 border-green-200",
  przecietnie: "bg-yellow-50 text-yellow-700 border-yellow-200",
  slabo: "bg-red-50 text-red-700 border-red-200",
};

export const LEVEL_DOT_CLASS: Record<ExamSrProgressLevel, string> = {
  bardzo_dobrze: "bg-green-600",
  dobrze: "bg-green-400",
  przecietnie: "bg-yellow-400",
  slabo: "bg-red-500",
};
